<template>
  <div class="tree-box">
      <div class="tree-wrapper">
          <img src="../assets/tree/star-shining.png" alt="" :class="{star: true, shining}" @click="$emit('check-own')" v-if="shining || (myWish && myWish.length)">
          <img src="../assets/tree/star.png" alt="" class="star" @click="$emit('check-own')" v-else>
          <img src="../assets/tree/sprite.png" alt="" class="sprite">

          <img src="../assets/tree/socks.png" alt="" class="socks socks1" @click="socks(0)">
          <img src="../assets/tree/socks.png" alt="" class="socks socks2" @click="socks(1)">
          <img src="../assets/tree/socks.png" alt="" class="socks socks3" @click="socks(2)">
          <img src="../assets/tree/socks.png" alt="" class="socks socks4" @click="socks(3)">
          <img src="../assets/tree/socks.png" alt="" class="socks socks5" @click="socks(4)">
          <img src="../assets/tree/socks.png" alt="" class="socks socks6" @click="socks(5)">
          <img src="../assets/tree/socks.png" alt="" class="socks socks7" @click="socks(6)">
          <img src="../assets/tree/socks.png" alt="" class="socks socks8" @click="socks(7)">
          <img src="../assets/tree/socks.png" alt="" class="socks socks9" @click="socks(8)">

          <img src="../assets/tree/candy.png" alt="" class="candy candy1" @click="randomWish">
          <img src="../assets/tree/candy.png" alt="" class="candy candy2" @click="randomWish">
          <img src="../assets/tree/candy.png" alt="" class="candy candy3" @click="randomWish">
          <img src="../assets/tree/fruit.png" alt="" class="fruit fruit1" @click="randomWish">
          <img src="../assets/tree/fruit.png" alt="" class="fruit fruit2" @click="randomWish">
          <img src="../assets/tree/ring.png" alt="" class="ring" @click="randomWish">
      </div>
      <img src="../assets/button-wish.png" alt="" class="button-wish" @click="goWish">
      <img src="../assets/button-up.png" alt="" class="button-up" @click="goShare">
  </div>
</template>

<script>
import * as api from '@/api/index'
export default {
    name: 'santaTree',
    mounted() {
        this.wishList()
    },
    props: ["makingWish", "myWish"],
    watch: {
        makingWish(newV, oldV) {
            if (newV.length) {
                this.shine()
                this.$emit('consumeWish')
            }
        }
    },
    data() {
        return {
            shining: false
        }
    },
    methods: {
        async randomWish() {
            this.$emit('check-random')
        },
        async socks(index) {
            this.$emit('check-detail', index)
        },
        async wishList() {
            const res = await api.wishList()
                .catch(err => {
                    console.log(err)
                })
            this.$emit('check-wish', res)
        },
        goWish(res) {
            this.$emit('go-wish', )
        },
        goShare(res) {
            this.$emit('go-share', )
        },
        shine() {
            this.shining = true
            setTimeout(() => {
                this.shining = false
            }, 3000)
        }
    }
}
</script>

<style lang="scss" scoped>
.tree-box {
    position: absolute;
    bottom: 3vw;
    width: 100%;
    display: flex;
    flex-direction: column;
}
.tree-wrapper {
    width: 94.537vw;
    height: 120.83vw;
    background-image: url("../assets/tree/tree.png");
    background-size: 100%;
    align-self: flex-end;
    .star {
        width: 14.167vw;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: -2vw;
    }
    .shining {
        animation: shine 3s;
        left: 43%;
    }
    .sprite {
        width: 12.68vw;
        position: absolute;
        top: 4vw;
        left: 36%;
        pointer-events: none;
    }
    .socks {
        width: 15.18vw;
        position: absolute;
    }
    .socks1 {top: 13vw;left:52vw;}
    .socks2 {top: 28vw;left:19vw;}
    .socks3 {top: 30vw;left:63vw;}
    .socks4 {top: 59vw;left:9vw;}
    .socks5 {top: 59vw;left:33vw;}
    .socks6 {top: 56vw;left:72vw;}
    .socks7 {top: 77vw;left:4vw;}
    .socks8 {top: 78vw;left:51vw;}
    .socks9 {top: 77vw;left:81vw;}
    .candy {
        width: 12.31vw;
        position: absolute;
        animation: swing infinite 1s alternate;
    }
    .candy1 {top: 31vw;left:42vw;}
    .candy2 {top: 62vw;left:53vw;}
    .candy3 {top: 80vw;left:28vw;}
    .fruit {
        width: 14.54vw;
        position: absolute;
        animation: swing ease-in-out infinite 1s alternate;
    }
    .fruit1 {top: 13vw;left:31vw;}
    .fruit2 {top: 43vw;left:27vw;}
    .ring {
        width: 13.89vw;
        position: absolute;
        top: 46vw; left: 52vw;
        animation: swing infinite 1s alternate;
    }
}
.button-wish {
    width: 71.11vw;
    margin: -11vw auto 0;
    display: block;
}
.button-up {
    width: 71.11vw;
    margin: -2vw auto 0;
    display: block;
}

 @keyframes swing { 
   0% { transform: rotate(4deg); }
    100% { transform: rotate(-4deg); }
}

@keyframes shine {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.2);
    }
    100% {
        transform: scale(1);
    }
}
</style>